import * as actions from '../actions'

var defaultState = null

export default function users(state = defaultState, action) {
    switch (action.type) {

        case actions.USER_GET:
            if (!action.error) {
                state = action.payload.data.objects
            }
            return state

        case actions.USER_CLEAN:
            return defaultState

        default:
            return state

    }
}



// WEBPACK FOOTER //
// ./state/reducers/users.js